import { Component } from '@angular/core';

@Component({
  templateUrl: './termsandconditions.html',
  standalone: false
})
export class TermsAndConditionsComponent { }
